import { motion } from "framer-motion";

const values = [
  { t: "Respeito", d: "pela tua história. É dela que parte tudo." },
  { t: "Empatia", d: "em vez de prescrição. Ouvir primeiro." },
  { t: "Excelência", d: "sem fórmula. A tua vida não cabe numa." },
  { t: "Confiança", d: "que se constrói, passo a passo." },
  { t: "Responsabilidade", d: "partilhada. Tu, a honestidade; eu, o método." },
  { t: "Aprendizagem", d: "que nunca termina. Em ti, em mim." },
];

export default function Manifesto() {
  return (
    <section
      id="manifesto"
      data-testid="manifesto-section"
      className="py-24 md:py-36 px-6 md:px-12 bg-cream-soft"
    >
      <div className="max-w-[1200px] mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.4 }}
          className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-14"
        >
          <div className="md:col-span-3">
            <span className="section-num">07 · Manifesto</span>
          </div>
          <div className="md:col-span-9">
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-ink leading-[1.02] mb-8">
              Aquilo em que <span className="brush-underline">acredito,</span>
              <br />
              <span className="font-serif-display text-orange normal-case lowercase">e deixei escrito aqui.</span>
            </h2>
            <p className="text-lg text-ink-soft max-w-2xl leading-relaxed mb-3">
              Podes viver a melhor versão de ti — não a mais perfeita, a mais <em>verdadeira</em>.
              Libertar-te do que te aprisiona. Aceitar-te. Tornar-te livre e em paz contigo.
            </p>
            <p className="font-serif-display text-lg text-ink-soft">
              O impossível só existe antes de sabermos como se faz.
            </p>
          </div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-line">
          {values.map((v, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-30px" }}
              transition={{ duration: 0.25, delay: i * 0.03 }}
              data-testid={`value-${i}`}
              className="bg-cream-soft p-7 hover:bg-cream transition-colors duration-300"
            >
              <div className="flex items-baseline gap-3 mb-3">
                <span className="font-display text-orange text-sm">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <h3 className="font-display text-xl text-ink">
                  {v.t}
                </h3>
              </div>
              <p className="text-ink-soft text-base leading-snug pl-9">{v.d}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
